<template>
  <div class="RedesignFooter">
    <footer>
      <!-- Misma jerarquía que el resto del sitio: fondo ancho + .container para alinear con navbar/logo -->
      <div class="fondo-gris">
        <div class="container">
          <div class="row enlaces-rapidos">
            <div class="col-md-3">
              <div class="logo-iff">
                <br />
                <img :alt="configData.general.brandName" src="@/assets/logo.png" />
              </div>
            </div>
            <div class="col-md-3">
              <h4 style="color: var(--primary-color); text-align: left;">
                <strong>ENLACES RÁPIDOS</strong>
              </h4>
              <br />
              <ul style="text-align: left; padding-left: 0px;">
                <template v-for="section in section_list">
                  <li style="list-style-type: none; margin-bottom: 8px;">
                    <router-link
                      :to="'/' + section.url_es"
                      style="font-size: 15px; text-decoration: none;"
                      ><span style="color: var(--secondary-color); font-weight: bold;">{{
                        section.name_sec_es
                      }}</span></router-link
                    >
                  </li>
                </template>
              </ul>
            </div>
            <div class="col-md-3">
              <br />
              <br />
              <ul style="text-align: left; padding-left: 0px;">
                <li
                  style="list-style-type: none; margin-bottom: 8px;"
                  v-if="configData.general.isLoggingAvailable"
                >
                  <a
                    href=""
                    style="font-size: 15px; text-decoration: none;"
                    data-toggle="modal"
                    data-target="#myModal2"
                    ><span style="color: var(--secondary-color); font-weight: bold;"
                      >Iniciar Sesión</span
                    ></a
                  >
                </li>
                <li
                  style="list-style-type: none; margin-bottom: 8px;"
                  v-if="configData.general.isLoggingAvailable"
                >
                  <router-link :to="'/registrar'" style="font-size: 15px; text-decoration: none;"
                    ><span style="color: var(--secondary-color); font-weight: bold;">
                      Mi Cuenta</span
                    ></router-link
                  >
                </li>
                <li
                  style="list-style-type: none; margin-bottom: 8px;"
                  v-if="configData.general.isEcommercePage"
                >
                  <router-link :to="'/carrito'" style="font-size: 15px; text-decoration: none;"
                    ><span style="color: var(--secondary-color); font-weight: bold;"
                      >Mi Carrito</span
                    ></router-link
                  >
                </li>
                <li style="list-style-type: none; margin-bottom: 8px;">
                  <a
                    :href="configData.general.corporateWebPage"
                    style="font-size: 15px; text-decoration: none;"
                  >
                    <span style="color: var(--secondary-color); font-weight: bold;">{{
                      configData.general.brandName
                    }}</span></a
                  >
                </li>
              </ul>
            </div>
            <div class="col-md-3">
              <h4 style="color: var(--primary-color); text-align: left;">
                <strong>MANTÉNGASE EN CONTACTO</strong>
              </h4>
              <br />
              <p style="color: var(--primary-color); text-align: left;">
                Manténgase actualizado en nuestras redes sociales.
              </p>
              <div class="social">
                <ul>
                  <li>
                    <a :href="configData.general.SocialNetworks.linkedIn" target="_blank"
                      ><i class="fa fa-linkedin"></i
                    ></a>
                  </li>
                  <li>
                    <a :href="configData.general.SocialNetworks.youtube" target="_blank"
                      ><i class="fa fa-youtube-play"></i
                    ></a>
                  </li>
                  <li>
                    <a :href="configData.general.SocialNetworks.youtube" target="_blank"
                      ><i class="fa fa-wechat"></i
                    ></a>
                  </li>
                  <li>
                    <a :href="configData.general.SocialNetworks.facebook" target="_blank"
                      ><i class="fa fa-facebook"></i
                    ></a>
                  </li>
                  <li>
                    <a :href="configData.general.SocialNetworks.twitter" target="_blank"
                      ><i class="fa fa-twitter"></i
                    ></a>
                  </li>
                  <li>
                    <a :href="configData.general.SocialNetworks.instagram" target="_blank"
                      ><i class="fa fa-instagram"></i
                    ></a>
                  </li>
                </ul>
              </div>
              <ul class="accesos">
                <li class="img-libro-reclamaciones">
                  <router-link :to="'/reclamo'" class="acceso link-libro-reclamaciones"></router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="fondo-gris">
        <div class="container">
          <div class="row">
            <div class="col-sm-3">
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.iff.com/privacy-statement"
                  style="font-size: 15px; text-decoration: none;"
                >
                  <span style="color: var(--secondary-color); font-weight: bold;">
                    Declaración de Privacidad
                  </span></a
                >
              </li>
            </div>
            <div class="col-sm-3">
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.iff.com/terms-of-use"
                  style="font-size: 15px; text-decoration: none;"
                >
                  <span style="color: var(--secondary-color); font-weight: bold;"
                    >Terminos de Uso</span
                  ></a
                >
              </li>
            </div>
            <div class="col-sm-3">
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.iff.com/privacy/cookie-policy"
                  style="font-size: 15px; text-decoration: none;"
                >
                  <span style="color: var(--secondary-color); font-weight: bold;"
                    >Políticas de Cookies</span
                  ></a
                >
              </li>
            </div>
            <div class="col-sm-3">
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="javascript:void(0)"
                  target="_parent"
                  onclick="truste.eu && truste.eu.clickListener()"
                  style="font-size: 15px; text-decoration: none;"
                >
                  <span style="color: var(--secondary-color); font-weight: bold;"
                    >Preferencias de cookies</span
                  ></a
                >
              </li>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="javascript:void(0)"
                  target="_parent"
                  onclick="truste.eu && truste.eu.clickListener()"
                  style="font-size: 15px; text-decoration: none;"
                >
                  <span style="color: var(--secondary-color); font-weight: bold;">
                    No venda ni comparta mi información personal
                  </span></a
                >
              </li>
            </div>
            <div class="col-sm-4">
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="https://www.iff.com/privacy/customer-and-vendor-privacy-notice"
                  style="font-size: 15px; text-decoration: none;"
                >
                  <span style="color: var(--secondary-color); font-weight: bold;"
                    >Aviso de Privacidad para Clientes y Proveedores</span
                  ></a
                >
              </li>
            </div>
            <div class="col-sm-4">
              <li style="list-style-type: none; margin-bottom: 8px;">
                <a
                  href="javascript:void(0)"
                  target="_parent"
                  onclick="truste.eu && truste.eu.clickListener()"
                  style="font-size: 15px; text-decoration: none;"
                >
                  <span style="color: var(--secondary-color); font-weight: bold;"
                    >Aviso de privacidad del solicitante de empleo</span
                  ></a
                >
              </li>
            </div>
          </div>
        </div>
      </div>
      <div class="fondo-gris">
        <div class="container copydev">
          <div class="copyright">
            Copyright © {{ getActualYear() + ' by ' + configData.general.brandShortName }}.
            {{ configData.general.brandShortName }} is a Registered Trademark. All Rights Reserved.
          </div>
          <div class="developed">
            Desarrollado por:
            <a :href="'http://' + configData.general.developerCorporateWebPage"
              ><img src="@/assets/analysofti-logo.png" :alt="configData.general.developerName"
            /></a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import data from '@/staticData.json';

export default {
  name: 'RedesignFooter',
  props: ['section_list'],
  data() {
    return {
      configData: data,
    };
  },
  methods: {
    getActualYear() {
      var today = new Date();
      var year = today.getFullYear();
      return year;
    },
  },
};
</script>

<style lang="scss" src="./RedesignFooter.scss"></style>
